import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex-brightworld/icons';

const Container = styled.div`
  text-align: ${props => props.align};
`;

const dimmensions = {
  small: '20px',
  medium: '30px',
  large: '40px'
};
const StyledIcon = styled(Icon)`
  color: ${props => props.theme.colors.shades[4]};
  width: ${props => dimmensions[props.originalSize]};
  height: ${props => dimmensions[props.originalSize]};
`;

function Loader(props) {
  return (
    <Container dataQa={props.qa} align={props.align}>
      <StyledIcon
        icon="loading"
        spin={props.spin}
        size={props.size === 'medium' ? 'normal' : 'large'}
        originalSize={props.size}
      />
    </Container>
  );
}

Loader.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  spin: PropTypes.bool,
  qa: PropTypes.string
};

Loader.defaultProps = {
  align: 'center',
  size: 'medium',
  spin: false,
  qa: undefined
};

export default Loader;
